import React from 'react';
import PropTypes from 'prop-types';
import { CardActionArea } from '@material-ui/core';
import { Typography } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../knock-design-system';

const useCss = makeCss({
  childContent: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    pointerEvents: 'none',
    width: '100%',
  },
  editContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
    '& .overlay': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      pointerEvents: 'none',
      visibility: 'hidden',
    },
    '&:hover .overlay': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      visibility: 'visible',
    },
  },
});

const EditOverlay = ({ actionOnClick, children }) => {
  const css = useCss();
  return (
    <CardActionArea css={css.editContainer} onClick={actionOnClick}>
      <div css={css.childContent}>{children}</div>

      <div className="overlay">
        <Typography align="center" color="common.white" variant="caption">
          Edit
        </Typography>
      </div>
    </CardActionArea>
  );
};

EditOverlay.propTypes = {
  actionOnClick: PropTypes.func,
  children: PropTypes.node,
};

export default EditOverlay;
